<template>
  <div>
    <div
      class="p-[14px_22px] bg-white w-full rounded-t-[6px] shadow-default grow"
    >
      <slot />
    </div>
    <div class="p-[14px_22px] w-full bg-blue-15 rounded-b-[6px] shadow-default">
      <slot name="footer" />
    </div>
  </div>
</template>
